import { atom } from 'recoil'
import { IProject } from '../../../Projects/projects.types'

interface ISelfProjectsAtomState {
  items: IProject[]
}

const selfProjectsAtom = atom<ISelfProjectsAtomState>({ default: { items: [] }, key: 'self/projects' })
export default selfProjectsAtom
